module.exports = __webpack_public_path__ + "img/doujiangyan.8766ace7.png";